import { createTheme } from '@mui/material/styles'

// Canonical tokens: .claude/docs/design-system.md. MUI reads CSS vars scoped to [data-theme]; the mode persists in localStorage 'recall.theme'.
const serif = '"Newsreader", Georgia, "Times New Roman", serif'
const sans = '"Geist", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'

export const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: '[data-theme="%s"]',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: '#5A7A3D', dark: '#445E2D', contrastText: '#FFFFFF' },
        secondary: { main: '#8B6B3F' },
        error: { main: '#B85547' },
        background: { default: '#FBF8F1', paper: '#FFFFFE' },
        // Mirrors --ink-2 in tokens.css (raised to clear WCAG AA on --surface-3).
        text: { primary: '#2C2618', secondary: 'rgba(44,38,24,0.80)' },
        divider: 'rgba(44,38,24,0.10)',
      },
    },
    dark: {
      palette: {
        primary: { main: '#9DC267', dark: '#7DA052', contrastText: '#14110D' },
        secondary: { main: '#C9A56B' },
        error: { main: '#D87264' },
        background: { default: '#14110D', paper: '#221E18' },
        // Mirrors --ink-2 in tokens.css (raised to clear WCAG AA on --surface-3).
        text: { primary: '#EFE9D9', secondary: 'rgba(239,233,217,0.78)' },
        divider: 'rgba(239,233,217,0.08)',
      },
    },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: sans,
    h1: { fontFamily: serif, fontWeight: 400, letterSpacing: '-0.02em' },
    h2: { fontFamily: serif, fontWeight: 500, letterSpacing: '-0.02em' },
    h3: { fontFamily: serif, fontWeight: 500, letterSpacing: '-0.015em' },
    h4: { fontFamily: serif, fontWeight: 500, letterSpacing: '-0.01em' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, paddingInline: 18 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          backgroundImage: 'none',
          border: `1px solid ${t.palette.divider}`,
          boxShadow: 'none',
          borderRadius: 20,
        }),
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 999 } },
    },
  },
})
